import Axios from "axios";
import { completeSubscription } from "./helpers";

// To navigate search "// {name of subject eg. Notifications}";

const devUrl = "http://localhost:8080";
const productionUrl = "https://calendar-next-gen-production.up.railway.app";
// const productionUrl = "http://localhost:8080";

export const API_GetWeather = (long, lat, timeZone) => {
  const res = Axios.get(
    `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${long}&hourly=temperature_2m,relativehumidity_2m,apparent_temperature,precipitation_probability,weathercode,windspeed_10m,winddirection_10m,windgusts_10m,temperature_80m&daily=windspeed_10m_max,uv_index_max,weathercode,temperature_2m_max,temperature_2m_min,sunrise,sunset,precipitation_probability_mean,precipitation_sum&current_weather=true&temperature_unit=fahrenheit&windspeed_unit=mph&precipitation_unit=inch&timezone=${timeZone}`,
  );
  return res;
};

const APIkey = "e942f755a159eeb9a8cff56a595afac5";
export const API_GetLocation = (lon, lat, limit) => {
  const res = Axios.get(
    `https://api.openweathermap.org/geo/1.0/reverse?lat=${lat}&lon=${lon}&limit=${limit}&appid=${APIkey}`,
  );
  return res;
};

export const getUserData = (token) => {
  const res = Axios.get(`${productionUrl}/user/data`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const getUserDataFresh = () => {
  const res = Axios.get(`${productionUrl}/fresh`);
  return res;
};

export const getGoogleData = async (token) => {
  const res = await Axios.get(
    `https://www.googleapis.com/oauth2/v1/userinfo?access_token=${token}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    },
  );
  return res;
};

export const loginWithGoogle = async (user) => {
  const res = await Axios.post(
    `${productionUrl}/login/google`,
    {
      user: {
        id: user.id,
        username: user.name,
        email: user.email,
        avatarUrl: user.picture,
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    },
  );
  return res;
};

export const loginWithFb = (fbToken) => {
  const res = Axios.post(`${productionUrl}/login/facebook`, {
    accessToken: fbToken,
  });
  return res;
};

export const loginWithPasswordAndUsername = async (credentials) => {
  const { username, email, password, avatarUrl } = credentials;
  const res = Axios.post(`${productionUrl}/login/classic`, {
    username,
    email,
    password,
    avatarUrl,
  });
  return res;
};

export const getGoogleCalendarEvents = async (authToken, accessToken) => {
  const res = await Axios.get(
    `${productionUrl}/google/calendar/events/${accessToken}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    },
  );
  return res;
};

export const getEvents = async (username, token) => {
  const res = await Axios.get(`${productionUrl}/${username}/events`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
      Accept: "appliction/json",
    },
  });
  return res;
};

export const fetchAttachments = async (eventId, token) => {
  const res = Axios.get(`${productionUrl}/attachments/${eventId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
};

export const postEvent = (event, token) => {
  const res = Axios.post(
    `${productionUrl}/new/event`,
    { event: event },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const updateStartAndEndTimeOnEvent = async (eventId, offset, token) => {
  const res = Axios.patch(
    `${productionUrl}/patch/event/startendtime`,
    { eventId, offset },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const API_UpdateEventTitle = (eventId, title, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/event/title`,
    {
      newTitle: title,
      eventId,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const API_UpdateEventDesc = (eventId, newDesc, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/event/desc`,
    {
      newDesc,
      eventId,
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const API_UpdateEventLocation = (eventId, location, token) => {
  return Axios.patch(
    `${productionUrl}/update/event/location`,
    { eventId, location },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

// Reminders
export const API_ToggleReminderPaused = (reminderId, toggle, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/reminder/pause`,
    { reminderId, toggle },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return res;
};

export const API_UpdateReminderTime = (newTime, reminderId, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/reminder/time`,
    { newTime, reminderId },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return res;
};

export const API_SnoozeReminderAndNotification = (
  reminderId,
  token,
  newTime,
  newSnoozes,
) => {
  const res = Axios.patch(
    `${productionUrl}/update/reminder/notification/snooze`,
    { reminderId, newTime, newSnoozes },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return res;
};

export const API_UpdateReminderSnoozeCount = (
  reminderId,
  newSnoozes,
  newTime,
  token,
) => {
  const res = Axios.patch(
    `${productionUrl}/update/reminder/snooze`,
    { reminderId, newSnoozes, newTime },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return res;
};

export const updateReminderNotes = (reminderId, newDesc, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/reminder/notes`,
    { reminderId: reminderId, newDesc: newDesc },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const updateReminderTitle = (reminderId, newTitle, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/reminder/title`,
    { reminderId: reminderId, newTitle: newTitle },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const createAttachments = (attachments, eventId, token) => {
  const res = Axios.post(
    `${productionUrl}/new/attachments/${eventId}`,
    { attachments },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const deleteEvent = (username, eventId, token) => {
  const res = Axios.delete(
    `${productionUrl}/${username}/delete/event/${eventId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const deleteRepeats = (username, eventId, eventParentId, token) => {
  const res = Axios.delete(
    `${productionUrl}/${username}/delete/events/${eventId}/${eventParentId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const updateEvent = (event, token) => {
  Axios.get(`${productionUrl}/${username}/events`)
    .then((res) => {
      console.log(res);
    })
    .catch((err) => {
      console.log(err);
    });
};

//Reminder api's
export const API_UpdateReminderAndNotificationIgnore = (
  newDevices,
  reminderId,
  token,
) => {
  const res = Axios.patch(
    `${productionUrl}/update/reminder/notification/ignore`,
    { reminderId, newDevices },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const getReminders = (username, token) => {
  const res = Axios.get(`${productionUrl}/${username}/reminders`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const updateReminderComplete = (reminderInfo, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/reminder/complete`,
    { reminder: reminderInfo },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const addReminder = (reminder, token) => {
  const res = Axios.post(
    `${productionUrl}/new/reminder`,
    { reminder },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const deleteReminder = (username, reminderId, token) => {
  const res = Axios.delete(
    `${productionUrl}/${username}/delete/reminder/${reminderId}`,
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return res;
};

export const deleteRemindersBulk = (ids, token) => {
  return Axios.delete(`${productionUrl}/delete/reminders/bulk`, {
    headers: { Authorization: `Bearer ${token}` },
    data: { ids },
  });
};

//Notifications

export const getNotificationsAtStart = (username, token) => {
  const res = Axios.get(`${productionUrl}/${username}/notifs`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const requestAndSubscribe = async (token) => {
  if ("serviceWorker" in navigator && "PushManager" in window) {
    const newSub = await checkPermissionsAndCreateNewSub();

    if (newSub === null) {
      return null;
    }

    return fetch(`${productionUrl}/subscribe/notifs`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newSub),
    });
  } else {
    console.warn("Push notifications are not supported");
  }
};

export const addSubscriptionToUser = (sub, token) => {
  const response = Axios.post(
    `${productionUrl}/add/subscription`,
    { sub: JSON.stringify(sub) },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const updateLastSeenOnDevice = (newSubs, token) => {
  const response = Axios.patch(
    `${productionUrl}/notif/lastseen`,
    { newSubs },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return response;
};

export const checkPermissionsAndCreateNewSub = async () => {
  if ("serviceWorker" in navigator && "PushManager" in window) {
    const reg = await navigator.serviceWorker.ready;
    if (!reg) return null;

    // Don't prompt again if already decided
    if (Notification.permission === "denied") {
      return null;
    }

    let permission = Notification.permission;

    if (permission === "default") {
      permission = await Notification.requestPermission();
    }

    if (permission !== "granted") {
      return null;
    }

    const publicVapidKey = import.meta.env.VITE_VAPID_PUBLIC_KEY || null;

    if (publicVapidKey === null)
      throw new Error("importing public vapid key failed. Check .env");

    const sub = await reg.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: publicVapidKey,
    });

    const completeSubscriptionObject = completeSubscription(sub);

    return completeSubscriptionObject;
  }
  return null;
};

export const API_PauseAllNotifications = (token) => {
  const res = Axios.patch(
    `${productionUrl}/pause/all/notifications`,
    {},
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return res;
};

export const removeNotificationSubFromServer = (newSubs, token) => {
  const res = Axios.patch(
    `${productionUrl}/remove/subscription`,
    { newSubs },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const createNotification = (newNotif, token) => {
  const res = Axios.post(
    `${productionUrl}/new/notification`,
    { notification: newNotif },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const getNotifications = (userId) => {
  const eventSource = new EventSource(
    `${productionUrl}/${userId}/notifications`,
  );
  return eventSource;
};

export const updateNotification = (idArray, token, username) => {
  const res = Axios.patch(
    `${productionUrl}/${username}/update/notif`,
    { notifs: idArray },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

// Notifications
export const API_SnoozeNotification = (notifId, newTime, token) => {
  const res = Axios.patch(
    `${productionUrl}/notification/snooze`,
    { notifId, newTime },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const markAsRead = (notifId) => {
  const res = Axios.post(`${productionUrl}/mark-as-read`, { notifId });
  return res;
};

export const markAsUnread = (notifId) => {
  const res = Axios.post(`${productionUrl}/mark-as-unread`, { notifId });
  return res;
};

export const deleteNotification = (token, id) => {
  const res = Axios.delete(`${productionUrl}/notification/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

// List apis
export const API_UpdateListItems = (listId, newItems, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/list/item`,
    { listId, newItems },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const getAllLists = (token, username) => {
  const res = Axios.get(`${productionUrl}/${username}/lists`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const createNewList = (token, username, newList) => {
  const res = Axios.post(
    `${productionUrl}/new/list/${username}`,
    { newList },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const updateListTitle = (listId, newTitle, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/list/title`,
    { listId, newTitle },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const deleteList = (token, listId) => {
  const res = Axios.delete(`${productionUrl}/delete/list/${listId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

//Tasks

export const updateTaskTitle = (taskId, newTitle, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/task/title`,
    { newTitle, taskId },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const getAllTasks = (token) => {
  const res = Axios.get(`${productionUrl}/all/tasks`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
};

export const createTask = (token, task) => {
  const res = Axios.post(
    `${productionUrl}/new/tasks`,
    { task },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

// General task update type
// const update = {
//   taskId: task.id,
//   taskItems: newItems,
// };

export const updateTasks = (token, taskUpdates) => {
  const res = Axios.post(
    `${productionUrl}/update/tasks`,
    { taskUpdates },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return res;
};

export const API_UpdateTaskColor = (token, taskId, newColor) => {
  const res = Axios.patch(
    `${productionUrl}/update/task/color`,
    { taskId, newColor },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
  return res;
};

export const deleteTask = (token, taskId) => {
  const res = Axios.delete(`${productionUrl}/delete/task/${taskId}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return res;
};

// Friend management
export const getFriendInfo = (token) => {
  const res = Axios.get(`${productionUrl}/friends/friendinfo`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const sendFriendRequestByEmail = (userEmail, token) => {
  const res = Axios.post(
    `${productionUrl}/friends/add/request/email/${userEmail}`,
    {},
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const acceptFriendRequest = (token, requestEmail) => {
  const res = Axios.post(
    `${productionUrl}/friends/accept/request`,
    { requestEmail: requestEmail },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const cancelAFriendRequest = (token, recipientsEmail) => {
  const res = Axios.delete(
    `${productionUrl}/friends/cancel/request/email/${recipientsEmail}`,
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

//Kanbans

export const createNewKanban = (token, kanban) => {
  const res = Axios.post(
    `${productionUrl}/kanban/new`,
    { kanban },
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    },
  );
  return res;
};

export const deleteKanbanBoard = (kanabanId, token) => {
  const res = Axios.delete(`${productionUrl}/kanban/delete/${kanabanId}`, {
    headers: { Authorization: `Bearer: ${token}` },
  });
  return res;
};

// Stickies

export const API_UpdateStickyPin = (newPin, stickyId, token) => {
  const res = Axios.patch(
    `${productionUrl}/update/sticky/pin`,
    { stickyId, newPin },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const addNewSticky = (token, sticky) => {
  const res = Axios.post(
    `${productionUrl}/add/sticky`,
    { sticky },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const updateSticky = (token, stickyId, stickyHtml) => {
  const res = Axios.put(
    `${productionUrl}/update/sticky`,
    { stickyId: stickyId, stickyHtml: stickyHtml },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};

export const deleteStickyNote = (token, stickyId) => {
  const res = Axios.delete(`${productionUrl}/delete/sticky/${stickyId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return res;
};

export const updateStickyView = (token, stickyId, newView) => {
  const res = Axios.put(
    `${productionUrl}/update/sticky/view`,
    { stickyId: stickyId, newView: newView },
    { headers: { Authorization: `Bearer ${token}` } },
  );
  return res;
};
